import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Search from "./RegSearchForm";
import Button from "react-bootstrap/lib/Button";
import {hashHistory} from "react-router";
import RegularisationTable from "./ReactTable/RegularisationTable";
import RegularisationTable2 from "./ReactTable/RegularisationTable2";
import * as actions from "../../../redux/actions/Attendance/attendanceActions";

const style = {
  height: 200,
  width: 300,
  margin: 20,
  textAlign: 'center',
  display: 'inline-block',
};
const stylePaperInfo = {
  height: "100%",
  width: "100%",
  padding: 0,
}

class MyAttendanceRegularisaton extends React.Component {

  constructor() {
    super();
    this.state = {value: 1, flag: true, data: [], series: []};
    this.handleSelect = this.handleSelect.bind(this);
    this.download_excel = this.download_excel.bind(this);
    this.form_submit = this.form_submit.bind(this);
    this.applyRegularisation = this.applyRegularisation.bind(this);
  }

  handleSelect(selectedKey) {
    if (selectedKey != this.state.value)
      this.setState({value: selectedKey, flag: !this.state.flag});
  }

  download_excel() {

  }

  getChartData(attendance) {

  }

  form_submit(request) {
    this.props.dispatch(actions.getRegularisationAttendance(request));
    this.setState({flag: !this.state.flag});
    this.props.dispatch(actions.getRegularisationAttendance(request));
    this.setState({flag: !this.state.flag});
  }

  applyRegularisation(request) {
    console.log(request);
    console.log(this.props.regDates);
    this.props.dispatch(actions.applyForRegularisation({data: request}, this.props.regDates));
    //this.props.dispatch(actions.applyForRegularisation(request,this.props.regDates));
  }

  componentDidMount() {
    this.props.changeBanner("MY REGULARISATION");
  }

  componentWillReceiveProps(props) {


  }

  render() {
    const actions = [
      <Button


        backgroundColor={'#428BCA'}
        onTouchTap={()=> {
          hashHistory.push('1/attendance/myAttendanceRegularisation')
        }

        }
      >Go Back</Button>
    ];


    const stylePaper = {
      height: "100%",
      width: "100%",
      paddingBottom: 5,
      marginTop: 10,
      textAlign: 'center',
      display: 'inline-block',
      borderTopStyle: 'solid',
      borderBottomStyle: 'solid',
      borderWidth: '1px',
      borderColor: '#008bcf',
      borderRadius: '0px',
    };


    console.log(this.props.state.attendanceRegularization);

    return (
      <div>
        <div role="tabpanel" className="tab-pane" id="apply">
          <div className="row clearfix">


            <div>
              <div className="col-md-12">

                {0 ? <div></div> :
                  <div>

                    <div className="col-md-12" style={{paddingLeft: 0}}>


                      <Search dates={this.props.regDates}
                              form_submit={this.form_submit}
                              change_date={this.props.changeRegDate}/>

                    </div>

                  </div>}


                {this.props.state.attendanceRegularization.length >= 0 ?
                  <div >
                    <div style={{marginLeft: '40%'}}>

                    </div>
                    <div style={stylePaper}>
                      {this.props.state.attendanceRegularization.length > 0 ?
                        <RegularisationTable name="form1"
                                             regularization={this.props.state.attendanceRegularization[0]}
                                             applyRegularisation={this.applyRegularisation}/> :
                        <div><h2>No Records Found</h2></div>}

                    </div>

                  </div> : <div style={{padding: '40px'}}><h3>No Records Found!!</h3></div>}


                {this.props.state.attendanceRegularization.length > 1 ? <div style={stylePaper}>
                  <RegularisationTable2 name="form2"
                                        regularization={this.props.state.attendanceRegularization[1]}
                                        applyRegularisation={this.applyRegularisation}/>
                </div> : <div></div>
                }
                {!(this.props.regPageNo == 0 && this.props.state.attendanceRegularization.length < 2) ?
                  <div style={{marginLeft: '40%', marginTop: '1%'}}>
                    <Button disabled={this.props.regPageNo > 0 ? false : true}
                            onClick={()=> {
                              this.props.changeRegPage(this.props.regPageNo - 1);
                            }}

                    >Previous</Button>

                    <Button disabled={(this.props.state.attendanceRegularization.length < 2 ) ? true : false}
                            style={{marginLeft: '25'}}
                            onClick={()=> {
                              this.props.changeRegPage(this.props.regPageNo + 1);
                            }}
                    >Next</Button>
                  </div> : null}


              </div>
            </div>
          </div>
        </div>
      </div>




    );
  }

}

MyAttendanceRegularisaton.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state.attendance[1],
    empId: state.emp[0].empno,
    loading: state.ajaxCallsInProgress

  };

}


export default connect(mapStateToProps)(MyAttendanceRegularisaton);




/** WEBPACK FOOTER **
 ** ./src/feature/attendance/MyAttendance/MyAttendanceRegularisaton.js
 **/